import React from 'react';

import { cssMap } from '@atlaskit/css';
import InformationCircleIcon from '@atlaskit/icon/core/information-circle';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { AIDisclaimer } from '@atlassian/ai-components/ai-disclaimer';

const styles = cssMap({
	root: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		paddingBlock: token('space.100'),
		paddingInline: token('space.200'),
		backgroundColor: token('elevation.surface'),
	},
});

/**
 * Sticky footer pinned below the InsightsFeed scroll area.
 * Uses the shared `AIDisclaimer` from `@atlassian/ai-components/ai-disclaimer`.
 */
export const InsightsFeedAiDisclaimer = (): JSX.Element => (
	<Box xcss={styles.root} testId="insights-feed-ai-disclaimer">
		<Inline alignBlock="center" space="space.050">
			<InformationCircleIcon label="" color={token('color.icon.subtle')} size="small" />
			<AIDisclaimer withLink />
		</Inline>
	</Box>
);
